export const STAGE_ID = '__node_editor_stage__'
export const DRAG_CONNECTION_ID = '__node_editor_drag_connection__'
export const CONNECTIONS_ID = '__node_editor_connections__'
